// @ts-nocheck

import { use, useEffect, useState } from "react";
import { db } from "../../db/db";
import { useLiveQuery } from "dexie-react-hooks";

import { API_BASE_URL as publicApiUrl } from "../../utils/api";

function TasksSend(id) {
  const tasks = useLiveQuery(async () => {
    return await db.carePlanTasks
      .where("postedSuccessfully")
      .equals(0)
      .toArray();
  });
  console.table(tasks)
  useEffect(() => {
    if (tasks) {
      if (tasks?.length > 0) {
        tasks
          .filter((task) => task.hasOwnProperty("value"))
          .map((task) => {
            const body = new URLSearchParams({
              save_new_record: "true",
              c: "ltgb2qzc31qn88xor",
              t: "l11_logged_care_plan_tasks",
              rdpartyintid_2: task["dateLogged"],
              client_1: task["clientId"],
              for_care_plan_task_0: task["id"],
              date_logged_0: task["dateLogged"],
              answer: task["value"],
              hc_visit_4: task["type"].includes("HC") ? task["visit"] : "",
              sl_session_4: task["type"].includes("SL") ? task["visit"] : "",
              com_out_visit_4: task["type"].includes("Com") ? task["visit"] : "",
            }).toString();
            // db.carePlanTasks.update(task["id"], {
            //   postedSuccessfully: 1,
            // });
            //   .catch((error) => console.log(error));
            fetch(`${publicApiUrl}/task`, {
              body: body,
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            })
              .then((res) => res.json())
              .then(() => {
                db.carePlanTasks
                  .update(task["id"], {
                    postedSuccessfully: 1,
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              });
          });
      }
    }
  }, [tasks]);

  return <></>;
}

export default TasksSend;
